import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { InvoicesService } from '../_services/invoices.service';

import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'
import { Invoice, Account, Debtor } from '../_models';
import { CustomerService } from '../_services';
import { currencysymbolPrefix } from '../_enums/debtordocumenttype';
import { AuthService } from '../_services/auth.service';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';
@Component({
    selector: 'salesinvoiceedit',
    templateUrl: './salesinvoiceedit.component.html'
})
export class SalesInvoiceEditComponent {

    public customer_public_id: string;

    public invoicePublic_key: any;
    public cusAccountPublicKey_temp: Account[] = [];
    public cusDebtor: Debtor[] = [];
    public invoiceForm: FormGroup;
    submitted = false;
    due_datetime: any;
    auth0Profile: any;
    ddltotalCurrencySymbol: any[];
    ddlLatefeeCurrencySymbol: any[];
    name: string;
    isalertVisiable = false;
    statusValue: any;

    constructor
        (
            private router: Router, private route: ActivatedRoute, private _fb: FormBuilder
            , private parameterData: ParameterData, private dataService: DataService
            , private invoicesService: InvoicesService, private customerService: CustomerService
            , private _currencysymbolPrefix: currencysymbolPrefix
            , private auth: AuthService
        ) {


        this.isalertVisiable = false;

        this.ddltotalCurrencySymbol = _currencysymbolPrefix.currencyPrefix;
        this.ddlLatefeeCurrencySymbol = _currencysymbolPrefix.currencyPrefix;


        this.dataService.currentInvoicePublicKey.subscribe((data) => {
            this.invoicePublic_key = data;
        });

        this.InitialSetup();


    }//end 


    InitialSetup() {

        this.invoiceForm = this._fb.group({
            invoice_id: new FormControl(""),
            metadata: this._fb.group({
                order_id: new FormControl(""),
                order_name: new FormControl("", Validators.required),
                order_description: new FormControl(""),
                tipoDe: new FormControl("")
            }),
            debtor: this._fb.group({
                public_id: new FormControl("Seleccione", Validators.required)
            }),
            total: this._fb.group({
                currency: new FormControl("Seleccione", Validators.required),
                value: new FormControl(0, Validators.required)
            }),

            terminos: new FormControl(""),
            create_datetime: new FormControl(new Date()),

            due_datetime: new FormControl(new Date()),
            late_fee: this._fb.group({
                currency: new FormControl("Seleccione", Validators.required),
                value: new FormControl(0, Validators.required)
            }),
            expiration_datetime: new FormControl(new Date()),
            creditor_account: this._fb.group({
                public_id: new FormControl("")
            })
        });
    }


    GetDebtorDetails() {
            
        this.customerService.getCustomerDebtorsList(this.customer_public_id).subscribe(data => {
            let resources = data["data"];
            this.cusDebtor = resources;

        },
            error => {
                console.log('Failed while trying to the Search All Result. ' + error);
            });
    }//end


    ngOnInit() {

        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');

        }

        let params: any = this.route.snapshot.params;
        this.invoicePublic_key = params.id;

        setTimeout(() => {
            this.customerService.getCustomerAccountList(this.customer_public_id).subscribe(data => {
                this.cusAccountPublicKey_temp = data;

                this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type == 'COLLECT' || t.type == 'RECEIVABLE'));

            });
        }, 500);
        this.GetDebtorDetails();
        if (this.invoicePublic_key != null && this.invoicePublic_key != 'invoice Key') {
            this.invoicesService.getInvoice(this.invoicePublic_key).subscribe((invoice: Invoice) => {


                setTimeout(() => {
                    this.name = invoice.name;
                    this.due_datetime = invoice.due_datetime;
                    this.invoiceForm = this._fb.group({
                        invoice_id: new FormControl(invoice.invoice_id),
                        metadata: this._fb.group({
                            order_id: new FormControl(invoice.metadata.order_id),
                            order_name: new FormControl(invoice.name, Validators.required),
                            order_description: new FormControl(invoice.metadata.order_description)
                        }),
                        debtor: this._fb.group({
                            public_id: new FormControl(invoice.debtor.public_id)
                        }),
                        total: this._fb.group({
                            currency: new FormControl(invoice.total.currency),
                            value: new FormControl(invoice.total.value, Validators.required)
                        }),




                        due_datetime: new FormControl((new Date(invoice.due_datetime)).toISOString()),
                        late_fee: this._fb.group({
                            currency: new FormControl(invoice.late_fee.currency, Validators.required),
                            value: new FormControl(invoice.late_fee.value, Validators.required)
                        }),
                        expiration_datetime: new FormControl((new Date(invoice.expiration_datetime)).toISOString()),
                        creditor_account: this._fb.group({
                            public_id: new FormControl(invoice.creditor_account.public_id)
                        })
                    });

                }, 500);
            })
        }
    }//end

    ngOnDestroy() {
        this.dataService.changeinvoicepublicKey('invoice Key');
    }



    checkCurrencyDetails(value) {

        if (this.invoiceForm.get('total.currency').value != value) {
            alert("Please select the Currency same Mora and Monto")
        }
    }


    onsubmit({ value }: { value: Invoice }) {

        value.creditor_account.public_id = this.cusAccountPublicKey_temp[0].public_id;
        value.invoice_id = value.metadata.order_id;


        if (value.total.currency == 'S/.') {
            value.late_fee.currency = 'PEN';
            value.late_fee.value = Number(value.late_fee.value);
            value.total.currency = 'PEN';
            value.total.value = Number(value.total.value);
        }

        if (value.total.currency == 'US$') {
            value.late_fee.currency = 'USD';
            value.late_fee.value = Number(value.late_fee.value);
            value.total.currency = 'USD';
            value.total.value = Number(value.total.value);
        }
        value.total.value = Number(value.total.value);
        value.late_fee.value = Number(value.late_fee.value);
        if (value.id === null) {
            value.id = 0;
        }
        if (this.invoicePublic_key != 'invoice Key') {
            if (value.total.currency == value.late_fee.currency) {
                this.invoicesService.updateInvoice(value, this.invoicePublic_key)
                    .subscribe((result) => {
                        this.statusValue = "La información fue creada correctamente !";
                        this.isalertVisiable = true;

                    }, error => {
                        console.log('Failed while trying to update the Invocie Details.' + error);
                    });
            }
            else {
                this.statusValue = "Please select the Currency same Mora and Monto!";
                this.isalertVisiable = true;
            }
        }
    }

    viewInvoiceList() {

        const application = localStorage.getItem('application');
        if (AccountTypeOptions[application] != undefined) {
            this.router.navigate([`/${AccountTypeOptions[application]}/invoices`]);
        }
    }

}//end class


